import { Action } from '@ngrx/store';

export const UPSERT = '[ORDER INFORMATION] BILLING DETAILS UPSERT';
export const CLEAR = '[ORDER INFORMATION] BILLING DETAILS CLEAR';

export class Upsert implements Action {
    readonly type = UPSERT;
    constructor(public payload: any) {
    }
}

export class Clear implements Action {
    readonly type = CLEAR;
    constructor() {
    }
}

export type BillingDetailsActions = Upsert
| Clear;


